<template>
  <button
    v-if="showDebugButton"
    class="button is-small debug-button"
    title="Debug in SnapQL Debugger"
    @click="openExplorer">
    <span class="icon is-small">
      <i class="mdi mdi-code-tags" />
    </span>
  </button>
</template>
<script>

  export default {
    props: {
      dashboardModule: {
        type: Object,
        required: true,
      },
      dashboardDataContext: {
        type: Object,
        required: true,
      },
      dashboardKey: {
        type: String,
        required: true,
      },
    },
    computed: {
      // Shown by ?debug=true, never by USE_SNAPQL — the flag now marks who is on
      // SnapQL, not who is debugging it. Read off the data context rather than
      // the route so the button survives navigation that drops the query.
      // MANAGE_DASHBOARDS matches the debugger page's own guard in the Vue 3
      // app — without it anyone can type the query param and reach a page that
      // bounces them straight back out.
      showDebugButton () {
        return Boolean(this.dashboardDataContext.debug)
          && this.$hasPermission('MANAGE_DASHBOARDS')
      },
    },
    methods: {
      openExplorer () {
        const baseUrl = this.$env.VUE_APP_VUE_3_CLIENT_URL
        const companyId = this.$route.params.company_id
        const params = new URLSearchParams({
          report: this.dashboardKey,
          module: this.dashboardModule.key,
        })
        const url = `${baseUrl}/company/${companyId}/tools/semantic_debug?${params.toString()}`
        window.open(url, '_blank')
      },
    },
  }
</script>
<style scoped lang="scss">
.debug-button {
  box-shadow: none !important;
  border: 1px solid #e0e0e0 !important;
  margin-right: 4px;
}
</style>
